"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendEndpoint = void 0;
const web_env_1 = require("@snapchat/web-env");
function backendEndpoint() {
    if ((0, web_env_1.isRunningOnServer)()) {
        const backendEndpoint = process.env.NEXT_PUBLIC_BACKEND_ENDPOINT;
        return backendEndpoint || "https://us-east-1.webattachments.sc-prod.net";
    }
    else {
        return "/api/proxy-to-backend";
    }
}
exports.backendEndpoint = backendEndpoint;
//# sourceMappingURL=endpoints.js.map